
import Vue from "vue";
import Component from "vue-class-component";

@Component<Select>({
  props: {
    value: {
      type: Object,
      default() {
        return { label: "Label", value: "", error: "", items: [] };
      }
    },
    v: {
      type: [Object, String, Array],
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    error: {
      type: String,
      default: undefined
    },
    items: {
      type: Array,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  }
})
export default class Select extends Vue {}
